module.exports = __webpack_public_path__ + "img/logo.e113043f.png";